export default __webpack_public_path__ + "static/media/chat-grey.7e82ce3e.svg";